module.exports = __webpack_public_path__ + "img/banner_exhibition.7c16811e.png";